module.exports = __webpack_public_path__ + "static/media/icon-query.a0aa6267.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/icon-query.svg
// module id = 349
// module chunks = 0